var _path, _path2, _path3, _circle, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangePin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 105,
    viewBox: "0 0 96 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.253397,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1447 74.6088C17.1447 74.6088 17.6256 71.9525 19.5167 78.1989C21.4077 84.4453 42.7914 98.1165 49.9494 87.0446C57.1074 75.9728 67.2273 88.3968 74.2178 85.074C81.2084 81.7511 82.3157 77.3657 77.1051 66.7989C71.8945 56.2321 84.7118 43.3559 71.9353 35.0779C59.1587 26.7998 69.0498 28.8335 69.0498 28.8335L68.9847 62.6301L51.8821 78.1355L17.1447 74.6088Z",
    fill: "url(#paint0_linear_216_2072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.518059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8521 41.7133C67.8521 41.7133 66.3666 41.6269 69.6564 40.1533C72.9461 38.6797 78.9846 25.8857 72.4452 22.666C65.9059 19.4462 72.0209 12.987 69.7321 9.33377C67.4432 5.68055 64.9695 5.36402 59.5398 8.97301C54.11 12.582 43.635 2.94273 39.9671 10.5945C36.2993 18.2462 42.5295 8.95615 42.5295 8.95615L57.8063 13.762L67.4411 22.1987L67.8521 41.7133Z",
    fill: "url(#paint1_linear_216_2072)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0769 34.0228C43.9676 34.0228 38.6726 29.2868 38.6201 29.2393C38.2682 28.9202 37.7318 28.9202 37.3799 29.2393C37.3271 29.2871 32.046 34.0228 26.9231 34.0228C26.4133 34.0228 26 34.4361 26 34.9459V46.0005C26 54.9559 32.6607 58.5343 37.6708 60.447C37.7768 60.4875 37.8884 60.5077 38 60.5077C38.1116 60.5077 38.2232 60.4874 38.3292 60.447C43.3393 58.5343 50 54.9558 50 46.0005V34.9459C50 34.4361 49.5867 34.0228 49.0769 34.0228ZM48.1538 46.0005C48.1538 53.556 42.7999 56.7164 38 58.595C33.2001 56.7164 27.8462 53.556 27.8462 46.0005V35.8277C32.2911 35.4389 36.4591 32.3861 38 31.1333C39.5409 32.3861 43.7089 35.4389 48.1538 35.8277V46.0005ZM31.5385 44.7538C31.5385 48.3167 34.4371 51.2154 38 51.2154C41.5629 51.2154 44.4615 48.3167 44.4615 44.7538C44.4615 41.1909 41.5629 38.2923 38 38.2923C34.4371 38.2923 31.5385 41.1909 31.5385 44.7538ZM42.6154 44.7538C42.6154 47.2988 40.5449 49.3692 38 49.3692C35.4551 49.3692 33.3846 47.2988 33.3846 44.7538C33.3846 42.2089 35.4551 40.1384 38 40.1384C40.5449 40.1384 42.6154 42.2089 42.6154 44.7538ZM36.8065 45.0242C36.4461 44.6637 35.8616 44.6637 35.5011 45.0242C35.1406 45.3847 35.1406 45.9691 35.5011 46.3296L36.4242 47.2527C36.6044 47.4329 36.8407 47.5231 37.0769 47.5231C37.3132 47.5231 37.5494 47.433 37.7296 47.2527L40.4988 44.4834C40.8593 44.1229 40.8593 43.5385 40.4988 43.178C40.1384 42.8175 39.5539 42.8175 39.1934 43.178L37.0769 45.2945L36.8065 45.0242Z",
    fill: "url(#paint2_linear_216_2072)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.7632,
    cy: 45.3159,
    r: 32.7632,
    stroke: "#9CC031",
    strokeOpacity: 0.4,
    strokeWidth: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5456 12.6279C44.215 12.0397 52.763 14.9196 59.309 20.6339C65.8551 26.3482 69.863 34.4289 70.4512 43.0983C71.0393 51.7677 68.1594 60.3157 62.4451 66.8618C56.7308 73.4078 48.6501 77.4158 39.9807 78.0039",
    stroke: "url(#paint3_linear_216_2072)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_216_2072",
    x1: 19.7231,
    y1: 42.5482,
    x2: 119.919,
    y2: 79.5942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CC031",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_216_2072",
    x1: 49.4801,
    y1: 42.2826,
    x2: 63.4508,
    y2: -15.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CC031",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_216_2072",
    x1: 38,
    y1: 60.5077,
    x2: 38,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_216_2072",
    x1: 41.5395,
    y1: -4.33567,
    x2: 45.8005,
    y2: 129.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A374E",
    stopOpacity: 0.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePin);
export default __webpack_public_path__ + "static/media/change_pin.eae4ae19fc2360f74235b4f17d50664d.svg";
export { ForwardRef as ReactComponent };